/* Thanksgiving Campaign 2025 - Foxx Life Sciences */

document.addEventListener('DOMContentLoaded', function() {
    initThanksgivingCouponCode();
    initThanksgivingLeafAnimations();
    // DISABLED - All SVG leaf animations on hover/click
    // initSubcategoryLeafClick();
    // initProductGridLeafClick();
    // initProductGridLeaves();
    // DISABLED - Mist/Cloud animations
    // initThanksgivingMist();
});

function initThanksgivingCouponCode() {
    document.querySelectorAll('.copy-btn').forEach(function(button, index) {
        button.addEventListener('click', function() {
            button.querySelector('i').style.color = "#FFD700"; // Golden color for Thanksgiving
            setTimeout(function() {
                button.querySelector('i').style.color = "#fff";
            }, 3000);

            var copiedElement = document.querySelectorAll('.copied')[index];
            copiedElement.classList.add('active');

            setTimeout(function() {
                copiedElement.classList.remove('active');
            }, 3000);

            var copyText = document.querySelectorAll('.copy-input')[index];
            copyText.disabled = false;
            copyText.readOnly = false;

            copyText.select();
            copyText.setSelectionRange(0, 99999);

            if (document.execCommand("copy")) {
                console.log("Thanksgiving coupon code copied to clipboard");
            } else {
                console.log("Copy command failed");
            }

            window.getSelection().removeAllRanges();

            copyText.disabled = true;
            copyText.readOnly = true;
        });
    });
}

function initThanksgivingLeafAnimations() {
    // Scroll animations for Thanksgiving decorations
    window.addEventListener('scroll', () => {
        var autumnElements = document.querySelectorAll('.autumn-element');

        autumnElements.forEach(element => {
            if (window.scrollY > 900) {
                element.style.display = "none";
            } else {
                element.style.display = "block";
            }
        });
    });
}

// Subcategory leaf animations - works with new 4-color implementation
/* DISABLED - SVG hover effects
function initSubcategoryLeafClick() {
    const subcategoryCards = document.querySelectorAll('.sidebarmenu_list');
    
    // Get random leaf color SVG
    function getRandomLeafSVG() {
        const colors = [
            // Bright Orange
            { id: 'hoverLeaf1', colors: ['#FF6B35', '#FF8C42', '#DA5700'], stroke: '#A0522D', vein: '#C1631F' },
            // Deep Red
            { id: 'hoverLeaf2', colors: ['#DC143C', '#C41E3A', '#8B0000'], stroke: '#8B2C2F', vein: '#A52A2A' },
            // Golden Orange
            { id: 'hoverLeaf3', colors: ['#FFD700', '#FFA500', '#FF8C00'], stroke: '#CD853F', vein: '#DAA520' },
            // Dark Burgundy
            { id: 'hoverLeaf4', colors: ['#9B111E', '#800020', '#5C0A14'], stroke: '#6B2C2F', vein: '#8B3A3A' }
        ];
        
        const randomColor = colors[Math.floor(Math.random() * colors.length)];
        
        return `<svg viewBox="0 0 100 120" xmlns="http://www.w3.org/2000/svg" style="width: 100%; height: 100%;">
            <defs>
                <linearGradient id="${randomColor.id}" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style="stop-color:${randomColor.colors[0]};stop-opacity:0.55"/>
                    <stop offset="50%" style="stop-color:${randomColor.colors[1]};stop-opacity:0.65"/>
                    <stop offset="100%" style="stop-color:${randomColor.colors[2]};stop-opacity:0.5"/>
                </linearGradient>
            </defs>
            <line x1="50" y1="85" x2="50" y2="110" stroke="#8B4513" stroke-width="2.5" stroke-linecap="round" opacity="0.5"/>
            <path d="M 50,8 Q 52,10 54,15 Q 56,18 58,16 L 64,10 Q 66,14 68,20 Q 70,26 72,32 Q 76,30 80,28 L 86,26 Q 88,30 90,36 Q 92,42 94,48 Q 92,52 88,54 Q 90,56 92,60 Q 90,64 86,68 Q 88,72 90,78 Q 86,80 80,82 Q 76,84 72,86 Q 70,90 68,94 L 62,88 Q 58,90 54,92 Q 52,88 50,86 Q 48,88 46,92 Q 42,90 38,88 L 32,94 Q 30,90 28,86 Q 24,84 20,82 Q 14,80 10,78 Q 12,72 14,68 Q 10,64 8,60 Q 10,56 12,54 Q 8,52 6,48 Q 8,42 10,36 Q 12,30 14,26 L 20,28 Q 24,30 28,32 Q 30,26 32,20 Q 34,14 36,10 L 42,16 Q 44,18 46,15 Q 48,10 50,8 Z" fill="url(#${randomColor.id})" stroke="${randomColor.stroke}" stroke-width="1.5" opacity="0.7"/>
            <path d="M 50,20 L 50,80" stroke="${randomColor.vein}" stroke-width="1.5" opacity="0.5"/>
            <path d="M 50,35 Q 38,45 28,50" stroke="${randomColor.vein}" stroke-width="1.2" opacity="0.45"/>
            <path d="M 50,35 Q 62,45 72,50" stroke="${randomColor.vein}" stroke-width="1.2" opacity="0.45"/>
        </svg>`;
    }
    
    subcategoryCards.forEach(card => {
        const subCategory = card.querySelector('.sub-category');
        if (!subCategory) return;
        
        let hoverLeafElement = null;
        
        // Add animated leaf on hover (bottom-left to top-right)
        card.addEventListener('mouseenter', function() {
            if (!hoverLeafElement) {
                hoverLeafElement = document.createElement('div');
                hoverLeafElement.className = 'subcategory-hover-leaf';
                hoverLeafElement.innerHTML = getRandomLeafSVG();
                subCategory.appendChild(hoverLeafElement);
                
                requestAnimationFrame(() => {
                    hoverLeafElement.classList.add('show');
                });
            }
        });
        
        // Remove animated leaf on mouse leave
        card.addEventListener('mouseleave', function() {
            if (hoverLeafElement) {
                hoverLeafElement.classList.remove('show');
                setTimeout(() => {
                    if (hoverLeafElement && hoverLeafElement.parentNode) {
                        hoverLeafElement.remove();
                        hoverLeafElement = null;
                    }
                }, 800);
            }
        });
        
        // Click animation - leaf flies from bottom-left to top-right
        card.addEventListener('click', function(e) {
            const rect = card.getBoundingClientRect();
            const clickX = rect.left + 10;
            const clickY = rect.top + rect.height - 10;
            
            const clickLeaf = document.createElement('div');
            clickLeaf.innerHTML = getRandomLeafSVG();
            clickLeaf.className = 'subcategory-click-leaf';
            clickLeaf.style.left = clickX + 'px';
            clickLeaf.style.top = clickY + 'px';
            
            document.body.appendChild(clickLeaf);
            
            requestAnimationFrame(() => {
                clickLeaf.classList.add('active');
            });
            
            setTimeout(() => {
                clickLeaf.remove();
            }, 1200);
        });
    });
}
*/

// Initialize product grid leaves with random colors
/* DISABLED - SVG hover effects
function initProductGridLeaves() {
    var leafColors = [
        { colors: ['#FF6B35', '#FF8C42', '#DA5700'], stroke: '#A0522D', vein: '#C1631F' },
        { colors: ['#DC143C', '#C41E3A', '#8B0000'], stroke: '#8B2C2F', vein: '#A52A2A' },
        { colors: ['#FFD700', '#FFA500', '#FF8C00'], stroke: '#CD853F', vein: '#DAA520' },
        { colors: ['#9B111E', '#800020', '#5C0A14'], stroke: '#6B2C2F', vein: '#8B3A3A' }
    ];
    
    function getLeafSVG(colorIndex, uniqueId) {
        var color = leafColors[colorIndex];
        return '<svg viewBox="0 0 100 120" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:100%"><defs><linearGradient id="prodGrad' + uniqueId + '" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" style="stop-color:' + color.colors[0] + ';stop-opacity:0.55"/><stop offset="50%" style="stop-color:' + color.colors[1] + ';stop-opacity:0.65"/><stop offset="100%" style="stop-color:' + color.colors[2] + ';stop-opacity:0.5"/></linearGradient></defs><line x1="50" y1="85" x2="50" y2="110" stroke="#8B4513" stroke-width="2.5" stroke-linecap="round" opacity="0.5"/><path d="M 50,8 Q 52,10 54,15 Q 56,18 58,16 L 64,10 Q 66,14 68,20 Q 70,26 72,32 Q 76,30 80,28 L 86,26 Q 88,30 90,36 Q 92,42 94,48 Q 92,52 88,54 Q 90,56 92,60 Q 90,64 86,68 Q 88,72 90,78 Q 86,80 80,82 Q 76,84 72,86 Q 70,90 68,94 L 62,88 Q 58,90 54,92 Q 52,88 50,86 Q 48,88 46,92 Q 42,90 38,88 L 32,94 Q 30,90 28,86 Q 24,84 20,82 Q 14,80 10,78 Q 12,72 14,68 Q 10,64 8,60 Q 10,56 12,54 Q 8,52 6,48 Q 8,42 10,36 Q 12,30 14,26 L 20,28 Q 24,30 28,32 Q 30,26 32,20 Q 34,14 36,10 L 42,16 Q 44,18 46,15 Q 48,10 50,8 Z" fill="url(#prodGrad' + uniqueId + ')" stroke="' + color.stroke + '" stroke-width="1.5" opacity="0.7"/><path d="M 50,20 L 50,80" stroke="' + color.vein + '" stroke-width="1.5" opacity="0.5"/><path d="M 50,35 Q 38,45 28,50" stroke="' + color.vein + '" stroke-width="1.2" opacity="0.45"/><path d="M 50,35 Q 62,45 72,50" stroke="' + color.vein + '" stroke-width="1.2" opacity="0.45"/></svg>';
    }
    
    var allProductCards = document.querySelectorAll('.grid-link__image');
    allProductCards.forEach(function(card, cardIndex) {
        var leaves = card.querySelectorAll('.product-card-leaf');
        var availableColors = [0, 1, 2, 3];
        
        leaves.forEach(function(leaf, leafIndex) {
            var randomIndex = Math.floor(Math.random() * availableColors.length);
            var colorIndex = availableColors[randomIndex];
            availableColors.splice(randomIndex, 1);
            
            var uniqueId = 'p' + cardIndex + '_' + leafIndex + '_' + Date.now();
            leaf.innerHTML = getLeafSVG(colorIndex, uniqueId);
        });
    });
}
*/

/* DISABLED - SVG hover effects
function initProductGridLeafClick() {
    const productCards = document.querySelectorAll('.grid__item');
    
    // Get random leaf color SVG
    function getRandomLeafSVG() {
        const colors = [
            { id: 'prodHover1', colors: ['#FF6B35', '#FF8C42', '#DA5700'], stroke: '#A0522D', vein: '#C1631F' },
            { id: 'prodHover2', colors: ['#DC143C', '#C41E3A', '#8B0000'], stroke: '#8B2C2F', vein: '#A52A2A' },
            { id: 'prodHover3', colors: ['#FFD700', '#FFA500', '#FF8C00'], stroke: '#CD853F', vein: '#DAA520' },
            { id: 'prodHover4', colors: ['#9B111E', '#800020', '#5C0A14'], stroke: '#6B2C2F', vein: '#8B3A3A' }
        ];
        
        const randomColor = colors[Math.floor(Math.random() * colors.length)];
        
        return `<svg viewBox="0 0 100 120" xmlns="http://www.w3.org/2000/svg" style="width: 100%; height: 100%;">
            <defs>
                <linearGradient id="${randomColor.id}" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style="stop-color:${randomColor.colors[0]};stop-opacity:0.55"/>
                    <stop offset="50%" style="stop-color:${randomColor.colors[1]};stop-opacity:0.65"/>
                    <stop offset="100%" style="stop-color:${randomColor.colors[2]};stop-opacity:0.5"/>
                </linearGradient>
            </defs>
            <line x1="50" y1="85" x2="50" y2="110" stroke="#8B4513" stroke-width="2.5" stroke-linecap="round" opacity="0.5"/>
            <path d="M 50,8 Q 52,10 54,15 Q 56,18 58,16 L 64,10 Q 66,14 68,20 Q 70,26 72,32 Q 76,30 80,28 L 86,26 Q 88,30 90,36 Q 92,42 94,48 Q 92,52 88,54 Q 90,56 92,60 Q 90,64 86,68 Q 88,72 90,78 Q 86,80 80,82 Q 76,84 72,86 Q 70,90 68,94 L 62,88 Q 58,90 54,92 Q 52,88 50,86 Q 48,88 46,92 Q 42,90 38,88 L 32,94 Q 30,90 28,86 Q 24,84 20,82 Q 14,80 10,78 Q 12,72 14,68 Q 10,64 8,60 Q 10,56 12,54 Q 8,52 6,48 Q 8,42 10,36 Q 12,30 14,26 L 20,28 Q 24,30 28,32 Q 30,26 32,20 Q 34,14 36,10 L 42,16 Q 44,18 46,15 Q 48,10 50,8 Z" fill="url(#${randomColor.id})" stroke="${randomColor.stroke}" stroke-width="1.5" opacity="0.7"/>
            <path d="M 50,20 L 50,80" stroke="${randomColor.vein}" stroke-width="1.5" opacity="0.5"/>
            <path d="M 50,35 Q 38,45 28,50" stroke="${randomColor.vein}" stroke-width="1.2" opacity="0.45"/>
            <path d="M 50,35 Q 62,45 72,50" stroke="${randomColor.vein}" stroke-width="1.2" opacity="0.45"/>
        </svg>`;
    }
    
    productCards.forEach(card => {
        const gridLink = card.querySelector('.grid-link');
        const gridImage = card.querySelector('.grid-link__image');
        if (!gridLink || !gridImage) return;
        
        let hoverLeafElement = null;
        
        // Add animated leaf on hover (bottom-left to top-right)
        gridLink.addEventListener('mouseenter', function() {
            if (!hoverLeafElement) {
                hoverLeafElement = document.createElement('div');
                hoverLeafElement.className = 'product-hover-leaf';
                hoverLeafElement.innerHTML = getRandomLeafSVG();
                gridImage.appendChild(hoverLeafElement);
                
                requestAnimationFrame(() => {
                    hoverLeafElement.classList.add('show');
                });
            }
        });
        
        // Remove animated leaf on mouse leave
        gridLink.addEventListener('mouseleave', function() {
            if (hoverLeafElement) {
                hoverLeafElement.classList.remove('show');
                setTimeout(() => {
                    if (hoverLeafElement && hoverLeafElement.parentNode) {
                        hoverLeafElement.remove();
                        hoverLeafElement = null;
                    }
                }, 800);
            }
        });
        
        // Click animation - leaf flies from bottom-left to top-right
        card.addEventListener('click', function(e) {
            const rect = card.getBoundingClientRect();
            const clickX = rect.left + 10;
            const clickY = rect.top + rect.height - 10;
            
            const clickLeaf = document.createElement('div');
            clickLeaf.innerHTML = getRandomLeafSVG();
            clickLeaf.className = 'product-click-leaf';
            clickLeaf.style.left = clickX + 'px';
            clickLeaf.style.top = clickY + 'px';
            
            document.body.appendChild(clickLeaf);
            
            requestAnimationFrame(() => {
                clickLeaf.classList.add('active');
            });
            
            setTimeout(() => {
                clickLeaf.remove();
            }, 1200);
        });
    });
}
*/

// DISABLED - Mist/Cloud animations
/* function initThanksgivingMist() {
    // Create container for mist effects if it doesn't exist
    let mistContainer = document.querySelector('.thanksgiving-site-decorations');
    if (!mistContainer) {
        mistContainer = document.createElement('div');
        mistContainer.className = 'thanksgiving-site-decorations';
        document.body.appendChild(mistContainer);
    }
    
    // Create 3 warm autumn mist clouds
    for (let i = 1; i <= 3; i++) {
        const mist = document.createElement('div');
        mist.className = 'thanksgiving-mist-fullpage thanksgiving-mist-page-' + i;
        mist.setAttribute('aria-hidden', 'true');
        mistContainer.appendChild(mist);
    }
} */
